import clientRoute from '../clientRoute';

export const getExpertiseTaskViewRoutes = (withSubjectFilesTab: boolean): string[] => {
    const routes = [clientRoute.expertiseTask, clientRoute.expertiseTaskSubject];
    if (withSubjectFilesTab) {
        routes.push(clientRoute.expertiseTaskFiles);
    }
    return routes;
};
